import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "flag-icons-cz",
  viewBox: "0 0 640 480"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 0h640v240H0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#d7141a",
  d: "M0 240h640v240H0z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#11457e",
  d: "M360 240 0 0v480z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }